import { IconDefinition } from '../../types';

const Filter: IconDefinition = {
  name: 'filter-o',
  definition: {
    viewBox: '0 0 512 512',
    pathData:
      'M479.968 0H32.038C3.613 0-10.729 34.487 9.41 54.627L192 237.255V424a31.996 31.996 0 0 0 10.928 24.082l64 55.983c20.438 17.883 53.072 3.68 53.072-24.082V237.255L502.595 54.627C522.695 34.528 508.45 0 479.968 0zM288 224v256l-64-56V224L32 32h448L288 224z'
  }
};

export default Filter;
